import { debounce } from "lodash";
import {
  apiGet,
  apiPut,
  apiPost,
  apiDelete,
  apiPatch,
} from "@redriver/cinnamon";

export const ActionTypes = {
  ValidateCanMoveSheet: `SHEETS/VALIDATE_CAN_MOVE_SHEET`,
  GetMoveSheetData: `SHEETS/GET_MOVE_SHEET_DATA`,
  MoveSheet: `SHEETS/MOVE_SHEET`,
  SetAgreementCompanyFilterMoveSheet: `SHEETS/SET_AGREEMENT_COMPANY_FILTER_MOVE_SHEET`,
};

export const validateCanMoveSheet = (submitParams) => {
  const { sheetId, ...destination } = submitParams;
  return apiPost(
    ActionTypes.ValidateCanMoveSheet,
    `sheets/${sheetId}/can-move`,
    {
      ...destination,
    },
  );
};

export const getMoveSheetData = (sheetId) => {
  return apiGet(ActionTypes.GetMoveSheetData, `sheets/${sheetId}/can-move`);
};

export const moveSheet = (submitParams, sheetId) =>
  apiPost(ActionTypes.MoveSheet, `sheets/${sheetId}/move`, submitParams);

export const setAgreementCompanyFilter = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.SetAgreementCompanyFilterMoveSheet,
    data,
  });
